import React, { useEffect, useState } from 'react';
import { FileText, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import api from '@/lib/api';
import { PublicHeader, PublicFooter } from '@/components/PublicShell';

export default function RegulationPage() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get('/public/settings').then((r) => setSettings(r.data));
  }, []);

  const pdfUrl = settings?.regulation_pdf_url;

  return (
    <div>
      <PublicHeader />
      <div className="mx-auto max-w-3xl px-4 sm:px-6 py-10">
        <div className="font-display text-4xl text-white">REGULAMENTO</div>
        <p className="text-muted-foreground">Como funciona o Campeonato de Bandas do Pub Garage 66.</p>

        {pdfUrl && (
          <div className="mt-6 flex flex-wrap items-center gap-3 rounded-lg border border-[color:hsla(42,92%,52%,0.35)] bg-[color:hsla(42,92%,52%,0.06)] p-4">
            <FileText className="w-6 h-6 text-[var(--g66-amber)] shrink-0" />
            <div className="flex-1 min-w-[200px]">
              <div className="font-semibold text-white">Regulamento oficial em PDF</div>
              <div className="text-xs text-muted-foreground">Versão completa e atualizada com todas as regras do campeonato.</div>
            </div>
            <a href={pdfUrl} target="_blank" rel="noreferrer" download data-testid="regulation-download-pdf">
              <Button className="bg-[var(--g66-amber)] text-black hover:bg-[var(--g66-amber-2)]">
                <Download className="w-4 h-4 mr-1" /> Baixar PDF
              </Button>
            </a>
          </div>
        )}

        <Card className="mt-6 border border-border bg-card">
          <CardContent className="p-6">
            <pre className="text-white/90 whitespace-pre-wrap font-sans text-[15px] leading-relaxed" data-testid="regulation-content">
              {settings?.regulation_text || 'Regulamento em breve.'}
            </pre>
          </CardContent>
        </Card>
      </div>
      <PublicFooter settings={settings} />
    </div>
  );
}
